<template>
  <div>
    <div class="title">
      <button
        class="qiehuan"
        :class="tableType == 1 ? 'ac' : ''"
        @click="changeType(1);"
      >
        选房师数据
      </button>
      <button
        class="qiehuan"
        :class="tableType == 2 ? 'ac' : ''"
        @click="changeType(2);"
      >
        选房师转化
      </button>
      <!--
        <button
          class="qiehuan"
          :class="tableType == 3 ? 'ac' : ''"
          @click="changeType(3);"
        >
          选房师客户详情
        </button>
      -->
    </div>
    <div class="block">
      <el-date-picker
        v-model="value"
        type="daterange"
        value-format="yyyy-MM-dd"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        @change="getlist();"
        :picker-options="pickerOptions"
      >
      </el-date-picker>
    </div>
    <div v-show="tableType == 1">
      <div v-if="!value1">未选定时间，默认展示昨天</div>
      <div v-if="value1">
        已选时间:开始时间:{{ value1[0] }}结束时间:{{ value1[1] }}
      </div>
      <el-table :data="list1">
        <el-table-column
          label="时间"
          prop="time"
          :filters="filterList11"
          :filter-method="filter1"
        >
        </el-table-column>

        <el-table-column
          label="人员"
          prop="name"
          :filters="filterList12"
          :filter-method="filter1"
        >
        </el-table-column>
        <el-table-column label="线上选房师">
          <el-table-column label="主动">
            <el-table-column label="主动私聊" prop="active_chat">
            </el-table-column>
            <el-table-column label="客户回复" prop="active_reply">
            </el-table-column>
          </el-table-column>
          <el-table-column label="被动">
            <el-table-column label="客服人数" prop="passive_chat">
            </el-table-column>
            <el-table-column label="已回复客户" prop="passive_reply">
            </el-table-column>
          </el-table-column>
          <el-table-column label="电话">
            <el-table-column label="主动电话" prop="active_call">
            </el-table-column>
            <el-table-column label="被动电话" prop="passive_call">
            </el-table-column>
          </el-table-column>
          <el-table-column label="意向">
            <el-table-column label="意向人数" prop="will_num"> </el-table-column
          ></el-table-column>
        </el-table-column>
        <el-table-column label="合作">
          <el-table-column label="方案">
            <el-table-column label="方案个数" prop="plan_num">
            </el-table-column>
            <el-table-column label="方案深度" prop="plan_depth">
            </el-table-column>
          </el-table-column>
        </el-table-column>
        <el-table-column label="线下选房师">
          <el-table-column label="约看">
            <el-table-column label="约看人数" prop="appoint_num">
            </el-table-column></el-table-column
          ><el-table-column label="带看">
            <el-table-column label="带看人数" prop="punch_num">
            </el-table-column></el-table-column
          ><el-table-column label="成交">
            <el-table-column label="成交客户" prop="deal_num"> </el-table-column
          ></el-table-column>
        </el-table-column>
        <el-table-column label="积分"> </el-table-column>
      </el-table>
    </div>
    <div v-show="tableType == 2">
      <div v-if="!value2">未选定时间，默认展示昨天</div>
      <div v-if="value2">
        已选时间:开始时间:{{ value2[0] }}结束时间:{{ value2[1] }}
      </div>
      <el-table :data="list2">
        <el-table-column label="时间" prop="time" :filters="filterList21"
          :filter-method="filter1"> </el-table-column>
          
        <el-table-column label="人员" prop="name" :filters="filterList22"
          :filter-method="filter1"> </el-table-column>
        <el-table-column label="意向">
          <el-table-column label="主动客服人数" prop="active_user" sortable>
          </el-table-column>
          <el-table-column label="意向人数" prop="active_will" sortable>
          </el-table-column>
          <el-table-column label="转化比" prop="active_rate" sortable>
          </el-table-column>
          <el-table-column
            label="被动客服人数"
            prop="passive_user"
            sortable
          ></el-table-column>
          <el-table-column
            label="意向人数"
            prop="passive_will"
            sortable
          ></el-table-column>
          <el-table-column
            label="转化比"
            prop="passive_rate"
            sortable
          ></el-table-column>
        </el-table-column>
        <el-table-column label="约看">
          <el-table-column label="约看人数" prop="appoint_num" sortable>
          </el-table-column>
          <el-table-column label="带看人数" prop="punch_num" sortable>
          </el-table-column>
          <el-table-column label="转化比" prop="punch_rate" sortable>
          </el-table-column>
        </el-table-column>
        <el-table-column label="带看">
          <el-table-column label="带看人数" prop="punch_num" sortable>
          </el-table-column
          ><el-table-column label="成交人数" prop="deal_num" sortable>
          </el-table-column
          ><el-table-column label="转化比" prop="deal_rate" sortable>
          </el-table-column>
        </el-table-column>
      </el-table>
    </div>
    <!--
      <div v-show="tableType == 3">
        <div v-if="!value3">未选定时间，默认展示最近一周</div>
        <div v-if="value3">
          已选时间:开始时间:{{ value3[0] }}结束时间:{{ value3[1] }}
        </div>
        <el-table :data="list3" :span-method="merge">
          <el-table-column label="人员" prop="队员"> </el-table-column>
          <el-table-column label="客户姓名" prop="用户姓名"> </el-table-column>
          <el-table-column label="咨询互动">
            <el-table-column label="互动条数" prop="互动条数" sortable>
            </el-table-column>
            <el-table-column label="首次互动" prop="首次互动"> </el-table-column>
            <el-table-column label="最新互动" prop="最新互动"> </el-table-column>
          </el-table-column>
          <el-table-column label="方案">
            <el-table-column label="方案人数" prop="方案个数" sortable>
            </el-table-column>
            <el-table-column label="首次方案" prop="首次方案"> </el-table-column>
            <el-table-column label="最新方案" prop="最新方案"> </el-table-column>
          </el-table-column>
          <el-table-column label="约看">
            <el-table-column label="约看次数" prop="约看次数" sortable>
            </el-table-column
            ><el-table-column label="首次约看" prop="首次约看"> </el-table-column
            ><el-table-column label="最新约看" prop="最新约看"> </el-table-column>
          </el-table-column>
          <el-table-column label="带看">
            <el-table-column label="带看次数" prop="带看次数" sortable>
            </el-table-column
            ><el-table-column label="首次带看" prop="首次带看"> </el-table-column
            ><el-table-column label="最新带看" prop="最新带看"> </el-table-column>
          </el-table-column>
          <el-table-column label="新需求与需求跟踪">
            <el-table-column label="跟踪条数" prop="跟踪条数" sortable>
            </el-table-column
            ><el-table-column label="首次跟踪" prop="首次跟踪"> </el-table-column
            ><el-table-column label="最新跟踪" prop="最新跟踪"> </el-table-column>
          </el-table-column>
          <el-table-column label="成交">
            <el-table-column label="成交时间" prop="成交时间" sortable>
            </el-table-column>
          </el-table-column>
        </el-table>
      </div>
    -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      filterList11:[{
        text:'暂无',
        value:'暂无'
      }],
      filterList12:[{
        text:'暂无',
        value:'暂无'
      }],
      filterList21:[{
        text:'暂无',
        value:'暂无'
      }],
      filterList22:[{
        text:'暂无',
        value:'暂无'
      }],
      tableType: 1,
      value: "",
      value1: "",
      value2: "",
      value3: "",
      list3: [],
      list2: [],
      list1: []
    };
  },
  mounted() {
    this.getlist1();
  },
  methods: {
    getlist() {
      if (this.tableType == 1) {
        this.getlist1();
      }
      if (this.tableType == 2) {
        this.getlist2();
        this.value2 = this.value;
      }
      if (this.tableType == 3) {
        this.getlist3();
        this.value3 = this.value;
      }
    },
    changeType(count) {
      this.tableType = count;
      if (count == 2 && this.list2.length == 0) {
        this.getlist2();
      }
      if (count == 3 && this.list3.length == 0) {
        this.getlist3();
      }
      this.value = "";
    },
    getlist1() {
      this.$open();
      this.$axios
        .get(this.$url_prefix + "getChooserData", {
          params: {
            time: this.value
          }
        })
        .then(res => {
          this.$close();
          console.log(res)
          
          let list = this.getfilterValue(res.data.data)
          this.filterList11 = list[0]
          this.filterList12 = list[1]
          this.list1 = res.data.data;
        }).catch((res)=>{
          this.$close()
          console.log(res)
        });
    },
    getlist2() {
      this.$open();
      this.$axios
        .get(this.$url_prefix + "getTransform", {
          params: {
            time: this.value
          }
        })
        .then(res => {
          this.$close();
          
          for (var item of res.data.data) {
            if (item["转化比1"] == "NaN%" || item["转化比1"] == "Infinity%") {
              item["转化比1"] = "0%";
            }
            if (item["转化比2"] == "NaN%" || item["转化比2"] == "Infinity%") {
              item["转化比2"] = "0%";
            }
            if (item["转化比3"] == "NaN%" || item["转化比3"] == "Infinity%") {
              item["转化比3"] = "0%";
            }
            if (item["转化比4"] == "NaN%" || item["转化比4"] == "Infinity%") {
              item["转化比4"] = "0%";
            }
          }
          let list = this.getfilterValue(res.data.data)
          this.filterList21 = list[0]
          this.filterList22 = list[1]
          this.list2 = res.data.data;
        }).catch(()=>{
          this.$close()
        });
    },
    getlist3() {
      this.$open();
      this.$axios
        .get(this.$url_prefix + "getBelong", {
          params: {
            time: this.value
          }
        })
        .then(res => {
          this.$close();
          this.list3 = res.data.body;
          console.log(res.data);
        });
    },
    merge({ row, column, rowIndex, columnIndex }) {
      let length1 = "";
      let length2 = "";
      let length11 = [];
      let length22 = [];
      for (var item of this.list3) {
        if (item.队员 == "廖海波") {
          length11.push(item);
        } else {
          length22.push(item);
        }
      }
      length1 = length11.length;
      length2 = length22.length;
      if (columnIndex === 0) {
        if (rowIndex === 0) {
          return {
            rowspan: length1,
            colspan: 1
          };
        } else if (rowIndex === length1) {
          return {
            rowspan: length2,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    getfilterValue(list){
          let timeList = new Set();
          let nameList = new Set()
          list.forEach((item)=>{
            timeList.add(item['time'])
            nameList.add(item['name'])
          })
          timeList = Array.from(timeList).sort((a,b)=>a-b)
          nameList = Array.from(nameList)
          timeList = timeList.map((item)=>{
            return {
              text:item,
              value:item
            }
          })
          nameList = nameList.map((item)=>{
            return {
              text:item,
              value:item
            }
          })
          return [timeList,nameList]
    },
    filter1(value,row,column){
      const property = column['property']
      return row[property]===value
    },
  }
};
</script>

<style>
/* 对于样式的切换的话，我们可以动态绑定一个class或者动态绑定样式，用三元判别来进行判断 */
.title {
  /* font-size:0;如果多个buton组件建有间距，可以设置布局或者使用sont-size为0来取消间距 */
  display: flex;
  justify-content: center;
}
.title .qiehuan {
  border: 1px solid;
}
.ac {
  background-color: rgb(127, 127, 192);
}
</style>



// WEBPACK FOOTER //
// src/page/xiaoshouCount.vue